/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Error,
  LetakListResponse,
  LetakLocalizationRequest,
  LetakLocalizationResponse,
  LetakRequest,
  LetakResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Letaks<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Letak
   * @name GetLetaks
   * @request GET:/letaks
   * @secure
   */
  getLetaks = (
    query?: {
      /** Sort by attributes ascending (asc) or descending (desc) */
      sort?: string;
      /** Return page/pageSize (default: true) */
      "pagination[withCount]"?: boolean;
      /** Page number (default: 0) */
      "pagination[page]"?: number;
      /** Page size (default: 25) */
      "pagination[pageSize]"?: number;
      /** Offset value (default: 0) */
      "pagination[start]"?: number;
      /** Number of entities to return (default: 25) */
      "pagination[limit]"?: number;
      /** Fields to return (ex: title,author) */
      fields?: string;
      /** Relations to return */
      populate?: string;
      /** Filters to apply */
      filters?: Record<string, any>;
      /** Locale to apply */
      locale?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<LetakListResponse, Error>({
      path: `/letaks`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Letak
   * @name PostLetaks
   * @request POST:/letaks
   * @secure
   */
  postLetaks = (data: LetakRequest, params: RequestParams = {}) =>
    this.request<LetakResponse, Error>({
      path: `/letaks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Letak
   * @name GetLetaksId
   * @request GET:/letaks/{id}
   * @secure
   */
  getLetaksId = (id: number, params: RequestParams = {}) =>
    this.request<LetakResponse, Error>({
      path: `/letaks/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Letak
   * @name PutLetaksId
   * @request PUT:/letaks/{id}
   * @secure
   */
  putLetaksId = (id: number, data: LetakRequest, params: RequestParams = {}) =>
    this.request<LetakResponse, Error>({
      path: `/letaks/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Letak
   * @name DeleteLetaksId
   * @request DELETE:/letaks/{id}
   * @secure
   */
  deleteLetaksId = (id: number, params: RequestParams = {}) =>
    this.request<number, Error>({
      path: `/letaks/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Letak
   * @name PostLetaksIdLocalizations
   * @request POST:/letaks/{id}/localizations
   * @secure
   */
  postLetaksIdLocalizations = (
    id: number,
    data: LetakLocalizationRequest,
    params: RequestParams = {},
  ) =>
    this.request<LetakLocalizationResponse, Error>({
      path: `/letaks/${id}/localizations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
